import { Icon } from '@iconify/react';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
// utils
import { fShortenNumber } from 'utils/formatNumber';
import { RootState, useSelector } from 'redux/store';
import useLocales from 'hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 10502831;

export default function WeeksTransactions() {
  const { translate } = useLocales();
  const { transationsCount } = useSelector(
    (state: RootState) => state.transactionCount
);

  return (
    <RootStyle>
      <Typography variant="h3">{fShortenNumber(transationsCount.weeklyTransactions)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
      {translate(`dashboard.${"This Week Transactions"}`)}
      </Typography>
    </RootStyle>
  );
}